import { Lesson } from "@jelly/lesson";
import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "eb6c64cd-b34c-4921-b121-ea667de4311a",
  publicId: "13",
  name: "Airborne Sound in buildings",
  difficulty: 2,
  contentTypes: { audio: true, interactive: true, video: false },

  body: [principle01, task01],
};

export default lesson;
